import { useCallback, useContext, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { isTokenExpired } from '@/helpers'
import services from '@/services/services'

import { getCreateReturnPayload } from '../useCreateReturn/helpers'
import useSummary from '../useSummary/useSummary'
import { getPreviewBonuses, getPreviewFeeMessages, getPreviewFees } from './helpers'

const useReturnPreview = () => {
  const { context, setContext } = useContext(AppContext)
  const { setPreviewFees, setPreviewBonuses, setPreviewFeeMessages } = useSummary()
  const { fetchDataCancellable: requestPreview, loading } = useFetch(services.getReturnPreview, {
    doInitialRequest: false,
  })

  const items = context.items
  const orderId = context.orderInfo.id

  const clearPreview = useCallback(() => {
    setPreviewFees({})
    setPreviewBonuses({})
    setPreviewFeeMessages([])
  }, [setPreviewFees, setPreviewBonuses, setPreviewFeeMessages])

  const updatePreview = useCallback(async () => {
    if (!orderId || !items.length || !localStorage.jwt || isTokenExpired(localStorage.jwt)) {
      clearPreview()
      return
    }

    try {
      const preview = await requestPreview({ payload: getCreateReturnPayload({ items }), orderId })
      if (!preview) {
        return
      }

      setPreviewFees(getPreviewFees(preview))
      setPreviewBonuses(getPreviewBonuses(preview))
      setPreviewFeeMessages(getPreviewFeeMessages(preview))
      setContext(context => ({ ...context, consentModal: preview.consent_modal }))
    } catch {
      clearPreview()
    }
  }, [
    items,
    orderId,
    setPreviewFees,
    setPreviewBonuses,
    setPreviewFeeMessages,
    setContext,
    requestPreview,
    clearPreview,
  ])

  useEffect(() => {
    updatePreview()
  }, [updatePreview])

  return { loading }
}

export default useReturnPreview
